import e, { createRef as t, Component as o } from "react";
import r from "react-dom";
import n from "../../../../node_modules/classnames/index.js";
import { Lightbox as i } from "../../containers/Lightbox/Lightbox.js";
import { Button as s } from "../../buttons/Button/Button.js";
import { If as a } from "../../general/If/If.js";
import { Icon as l } from "../../general/Icon/Icon.js";
import { componentName as c } from "../../../utils/bem/index.js";
import { t as p } from "../../../i18/index.js";
function u(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function f(e, t) {
  for (var o = 0; o < t.length; o++) {
    var r = t[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function d(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function h(e) {
  return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function m(e, t) {
  return (m = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var b = function (o) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && m(e, t);
  }(g, o);
  var p,
    b,
    y,
    v = (p = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        o = h(g);
      if (p) {
        var r = h(this).constructor;
        t = Reflect.construct(o, arguments, r);
      } else t = o.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : u(this);
    });
  function g() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, g), e = v.apply(this, arguments), d(u(e), "bodyRef", t()), d(u(e), "footerRef", t()), d(u(e), "resizeObserver", void 0), d(u(e), "state", {
      showDivider: !1
    }), d(u(e), "observeResize", function () {
      e.resizeObserver = new ResizeObserver(function () {
        return e.toggleDivider();
      }), e.resizeObserver.observe(e.bodyRef.current);
    }), d(u(e), "onScroll", function () {
      var t = e.bodyRef.current,
        o = t.scrollTop,
        r = t.scrollHeight;
      o + t.clientHeight >= r ? e.setState({
        showDivider: !1
      }) : e.setState({
        showDivider: !0
      });
    }), d(u(e), "onEnter", function () {
      e.props.applyOnEnter && e.props.onApply();
    }), e;
  }
  return b = [{
    key: "toggleDivider",
    value: function value() {
      var e = this.bodyRef.current.scrollHeight > this.bodyRef.current.clientHeight;
      this.setState({
        showDivider: e
      });
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.observeResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.resizeObserver.disconnect();
    }
  }, {
    key: "renderElement",
    value: function value() {
      var t = this.state.showDivider,
        o = c("dialog", this.props.className, d({}, this.props.size, this.props.size)),
        r = n("dialog__footer", t && "dialog__footer--has-divider");
      return e.createElement(i, {
        onEsc: this.props.onCancel,
        onEnter: this.onEnter,
        containerAttributes: this.props.containerAttributes
      }, e.createElement("div", {
        className: o
      }, e.createElement("div", {
        className: "dialog__header"
      }, e.createElement("div", {
        className: "dialog__title"
      }, this.props.title), !this.props.hideCloseButton && e.createElement(l, {
        light: !0,
        name: "times",
        className: "dialog__close-button dont-grow",
        onClick: this.props.onCancel
      })), e.createElement("div", {
        ref: this.bodyRef,
        className: "dialog__body qa-dialog-body",
        onScroll: this.onScroll
      }, this.props.children), e.createElement("div", {
        ref: this.footerRef,
        className: r
      }, this.props.additionalButtons, e.createElement(a, {
        condition: !this.props.hideCancelButton
      }, e.createElement(s, {
        size: "large",
        autoWidth: !0,
        className: "dialog__cancel-button qa-cancel-button",
        label: this.props.labelCancel,
        onClick: this.props.onCancel,
        disabled: this.props.disabled
      })), e.createElement(a, {
        condition: !this.props.hideApplyButton
      }, e.createElement(s, {
        size: "large",
        autoWidth: !0,
        variant: this.props.variant,
        className: "dialog__confirm-button",
        label: this.props.labelApply,
        isLoading: this.props.isApplying,
        onClick: this.props.onApply,
        disabled: this.props.disableApplyButton || this.props.disabled
      })))));
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.renderElement();
      return this.props.appendTo ? r.createPortal(e, this.props.appendTo) : e;
    }
  }], f(g.prototype, b), y && f(g, y), g;
}(o);
d(b, "displayName", "Dialog"), d(b, "defaultProps", {
  labelCancel: p("cancel"),
  labelApply: p("ok"),
  variant: "primary",
  size: "medium",
  applyOnEnter: !0
});
export { b as Dialog };